import { apiGet, apiPost, apiPut, apiDelete } from "@redriver/cinnamon";
import { BoilerPlateStatus } from "features/../../../shared/constants/enums";

const NAMESPACE = "ADMIN/INITIAL_SCHEDULE_TERMS";

const ActionTypes = {
  ListAdditionalManagedVolumeUnits: `${NAMESPACE}/LIST_ADDITIONAL_MANAGED_VOLUME_UNITS`,
  GetAdditionalManagedVolumeUnits: `${NAMESPACE}/GET_ADDITIONAL_MANAGED_VOLUME_UNITS`,
  CreateAdditionalManagedVolumeUnits: `${NAMESPACE}/CREATE_ADDITIONAL_MANAGED_VOLUME_UNITS`,
  UpdateAdditionalManagedVolumeUnits: `${NAMESPACE}/UPDATE_ADDITIONAL_MANAGED_VOLUME_UNITS`,
  DeleteAdditionalManagedVolumeUnits: `${NAMESPACE}/DELETE_ADDITIONAL_MANAGED_VOLUME_UNITS`,
  DownloadAdditionalManagedVolumeUnits: `${NAMESPACE}/DOWNLOAD_ADDITIONAL_MANAGED_VOLUME_UNITS`,
  ApproveAdditionalManagedVolumeUnits: `${NAMESPACE}/APPROVE_ADDITIONAL_MANAGED_VOLUME_UNITS`,
  MakeAdditionalManagedVolumeUnitsLive: `${NAMESPACE}/MAKE_ADDITIONAL_MANAGED_VOLUME_UNITS_LIVE`,

  ListSettlementConsideration: `${NAMESPACE}/LIST_SETTLEMENT_CONSIDERATION`,
  GetSettlementConsideration: `${NAMESPACE}/GET_SETTLEMENT_CONSIDERATION`,
  CreateSettlementConsideration: `${NAMESPACE}/CREATE_SETTLEMENT_CONSIDERATION`,
  UpdateSettlementConsideration: `${NAMESPACE}/UPDATE_SETTLEMENT_CONSIDERATION`,
  DeleteSettlementConsideration: `${NAMESPACE}/DELETE_SETTLEMENT_CONSIDERATION`,
  DownloadSettlementConsideration: `${NAMESPACE}/DOWNLOAD_SETTLEMENT_CONSIDERATION`,
  ApproveSettlementConsideration: `${NAMESPACE}/APPROVE_SETTLEMENT_CONSIDERATION`,
  MakeSettlementConsiderationLive: `${NAMESPACE}/MAKE_SETTLEMENT_CONSIDERATION_LIVE`,

  ListIntroductionPayment: `${NAMESPACE}/LIST_INTRODUCTION_PAYMENT`,
  GetIntroductionPayment: `${NAMESPACE}/GET_INTRODUCTION_PAYMENT`,
  CreateIntroductionPayment: `${NAMESPACE}/CREATE_INTRODUCTION_PAYMENT`,
  UpdateIntroductionPayment: `${NAMESPACE}/UPDATE_INTRODUCTION_PAYMENT`,
  DeleteIntroductionPayment: `${NAMESPACE}/DELETE_INTRODUCTION_PAYMENT`,
  DownloadIntroductionPayment: `${NAMESPACE}/DOWNLOAD_INTRODUCTION_PAYMENT`,
  ApproveIntroductionPayment: `${NAMESPACE}/APPROVE_INTRODUCTION_PAYMENT`,
  MakeIntroductionPaymentLive: `${NAMESPACE}/MAKE_INTRODUCTION_PAYMENT_LIVE`,
};

const buildUploadObject = (templateUpload, uploadDoc) =>
  !uploadDoc
    ? null
    : {
        name: templateUpload.name,
        content: uploadDoc.split(",")[1],
        size: templateUpload.size,
        contentType: templateUpload.type,
      };

// Additional Managed Volume Units

export const listAdditionalManagedVolumeUnitTerms = (
  { filters, pagination },
  { dealerId },
) =>
  apiGet(
    ActionTypes.ListAdditionalManagedVolumeUnits,
    `dealers/${dealerId}/initial-schedule-terms/additional-managed-volume-units`,
    { ...filters, ...pagination },
  );

export const getAdditionalManagedVolumeUnitTerms = ({ dealerId, itemId }) =>
  apiGet(
    ActionTypes.GetAdditionalManagedVolumeUnits,
    `dealers/${dealerId}/initial-schedule-terms/additional-managed-volume-units/${itemId}`,
  );

export const createAdditionalManagedVolumeUnitTerms = (
  { templateUpload, ...data },
  { dealerId, uploadDoc },
) =>
  apiPost(
    ActionTypes.CreateAdditionalManagedVolumeUnits,
    `dealers/${dealerId}/initial-schedule-terms/additional-managed-volume-units`,
    {
      ...data,
      dealerId,
      templateUpload: buildUploadObject(templateUpload, uploadDoc),
    },
  );

export const updateAdditionalManagedVolumeUnitTerms = (
  { templateUpload, ...data },
  { dealerId, itemId, uploadDoc },
) =>
  apiPut(
    ActionTypes.UpdateAdditionalManagedVolumeUnits,
    `dealers/${dealerId}/initial-schedule-terms/additional-managed-volume-units/${itemId}`,
    {
      ...data,
      dealerId,
      itemId,
      templateUpload: buildUploadObject(templateUpload, uploadDoc),
    },
  );

export const deleteAdditionalManagedVolumeUnitTerms = ({ dealerId, itemId }) =>
  apiDelete(
    ActionTypes.DeleteAdditionalManagedVolumeUnits,
    `dealers/${dealerId}/initial-schedule-terms/additional-managed-volume-units/${itemId}`,
  );

export const downloadAdditionalManagedVolumeUnitTerms = ({ id, dealerId }) => {
  console.log(
    "downloadAdditionalManagedVolumeUnitTerms called with dealerId:",
    dealerId,
  );
  return apiGet(
    ActionTypes.DownloadAdditionalManagedVolumeUnits,
    `dealers/${dealerId}/initial-schedule-terms/additional-managed-volume-units/${id}/download`,
  );
};

export const approveAdditionalManagedVolumeUnitTerms = ({ id, dealerId }) =>
  apiPut(
    ActionTypes.ApproveAdditionalManagedVolumeUnits,
    `dealers/${dealerId}/initial-schedule-terms/additional-managed-volume-units/${id}/approve`,
  );

export const makeAdditionalManagedVolumeUnitTermsLive = ({ id, dealerId }) =>
  apiPut(
    ActionTypes.MakeAdditionalManagedVolumeUnitsLive,
    `dealers/${dealerId}/initial-schedule-terms/additional-managed-volume-units/${id}/status`,
    { status: BoilerPlateStatus.Live },
  );

// Settlement Consideration

export const listSettlementConsiderationTerms = (
  { filters, pagination },
  { dealerId },
) =>
  apiGet(
    ActionTypes.ListSettlementConsideration,
    `dealers/${dealerId}/initial-schedule-terms/settlement-consideration`,
    { ...filters, ...pagination },
  );

export const getSettlementConsiderationTerms = ({ dealerId, itemId }) =>
  apiGet(
    ActionTypes.GetSettlementConsideration,
    `dealers/${dealerId}/initial-schedule-terms/settlement-consideration/${itemId}`,
  );

export const createSettlementConsiderationTerms = (
  { templateUpload, ...data },
  { dealerId, uploadDoc },
) =>
  apiPost(
    ActionTypes.CreateSettlementConsideration,
    `dealers/${dealerId}/initial-schedule-terms/settlement-consideration`,
    {
      ...data,
      dealerId,
      templateUpload: buildUploadObject(templateUpload, uploadDoc),
    },
  );

export const updateSettlementConsiderationTerms = (
  { templateUpload, ...data },
  { dealerId, itemId, uploadDoc },
) =>
  apiPut(
    ActionTypes.UpdateSettlementConsideration,
    `dealers/${dealerId}/initial-schedule-terms/settlement-consideration/${itemId}`,
    {
      ...data,
      dealerId,
      itemId,
      templateUpload: buildUploadObject(templateUpload, uploadDoc),
    },
  );

export const deleteSettlementConsiderationTerms = ({ dealerId, itemId }) =>
  apiDelete(
    ActionTypes.DeleteSettlementConsideration,
    `dealers/${dealerId}/initial-schedule-terms/settlement-consideration/${itemId}`,
  );

export const downloadSettlementConsiderationTerms = ({ id, dealerId }) =>
  apiGet(
    ActionTypes.DownloadSettlementConsideration,
    `dealers/${dealerId}/initial-schedule-terms/settlement-consideration/${id}/download`,
  );

export const approveSettlementConsiderationTerms = ({ id, dealerId }) =>
  apiPut(
    ActionTypes.ApproveSettlementConsideration,
    `dealers/${dealerId}/initial-schedule-terms/settlement-consideration/${id}/approve`,
  );

export const makeSettlementConsiderationTermsLive = ({ id, dealerId }) =>
  apiPut(
    ActionTypes.MakeSettlementConsiderationLive,
    `dealers/${dealerId}/initial-schedule-terms/settlement-consideration/${id}/status`,
    { status: BoilerPlateStatus.Live },
  );

// Introduction Payment

export const listIntroductionPaymentTerms = (
  { filters, pagination },
  { dealerId },
) =>
  apiGet(
    ActionTypes.ListIntroductionPayment,
    `dealers/${dealerId}/initial-schedule-terms/introduction-payment`,
    { ...filters, ...pagination },
  );

export const getIntroductionPaymentTerms = ({ dealerId, itemId }) =>
  apiGet(
    ActionTypes.GetIntroductionPayment,
    `dealers/${dealerId}/initial-schedule-terms/introduction-payment/${itemId}`,
  );

export const createIntroductionPaymentTerms = (
  { templateUpload, ...data },
  { dealerId, uploadDoc },
) =>
  apiPost(
    ActionTypes.CreateIntroductionPayment,
    `dealers/${dealerId}/initial-schedule-terms/introduction-payment`,
    {
      ...data,
      dealerId,
      templateUpload: buildUploadObject(templateUpload, uploadDoc),
    },
  );

export const updateIntroductionPaymentTerms = (
  { templateUpload, ...data },
  { dealerId, itemId, uploadDoc },
) =>
  apiPut(
    ActionTypes.UpdateIntroductionPayment,
    `dealers/${dealerId}/initial-schedule-terms/introduction-payment/${itemId}`,
    {
      ...data,
      dealerId,
      itemId,
      templateUpload: buildUploadObject(templateUpload, uploadDoc),
    },
  );

export const deleteIntroductionPaymentTerms = ({ dealerId, itemId }) =>
  apiDelete(
    ActionTypes.DeleteIntroductionPayment,
    `dealers/${dealerId}/initial-schedule-terms/introduction-payment/${itemId}`,
  );

export const downloadIntroductionPaymentTerms = ({ id, dealerId }) =>
  apiGet(
    ActionTypes.DownloadIntroductionPayment,
    `dealers/${dealerId}/initial-schedule-terms/introduction-payment/${id}/download`,
  );

export const approveIntroductionPaymentTerms = ({ id, dealerId }) =>
  apiPut(
    ActionTypes.ApproveIntroductionPayment,
    `dealers/${dealerId}/initial-schedule-terms/introduction-payment/${id}/approve`,
  );

export const makeIntroductionPaymentTermsLive = ({ id, dealerId }) =>
  apiPut(
    ActionTypes.MakeIntroductionPaymentLive,
    `dealers/${dealerId}/initial-schedule-terms/introduction-payment/${id}/status`,
    { status: BoilerPlateStatus.Live },
  );
